import { render, staticRenderFns } from "./Rekening.vue?vue&type=template&id=1a8e2ebc&scoped=true&"
import script from "./Rekening.vue?vue&type=script&lang=js&"
export * from "./Rekening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8e2ebc",
  null
  
)

export default component.exports